import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestJobsRetryPost = {
    path: "/jobs/retry",
    method: RouteHttpVerb.POST
};
